import axios from 'axios';
import { BASE_URL, CONTENT_API_PATH } from 'constants/api';
import { ShortsMetaInterface } from '../types/shortsMetaType';

const urlFor = (contentId: number) =>
  `${BASE_URL}${CONTENT_API_PATH}${contentId}/shorts-meta/`;

export const shortsMetaService = {
  /** ShortsMeta 조회. 미존재(404) 시 null. */
  async fetch(contentId: number): Promise<ShortsMetaInterface | null> {
    try {
      const response = await axios.get<ShortsMetaInterface>(urlFor(contentId));
      return response.data;
    } catch (e: any) {
      if (e?.response?.status === 404) return null;
      throw e;
    }
  },

  /** Upsert. content_type='shorts' 일 때만 허용 (BE에서 400 반환). */
  async upsert(
    contentId: number,
    data: Partial<ShortsMetaInterface>,
  ): Promise<ShortsMetaInterface> {
    const response = await axios.put<ShortsMetaInterface>(urlFor(contentId), data);
    return response.data;
  },

  async remove(contentId: number): Promise<void> {
    await axios.delete(urlFor(contentId));
  },
};
